import { Component } from '@angular/core';
import {
  MatDialogRef,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose,
} from '@angular/material/dialog';
import { UserJourneyService } from '../pages/onboarding-steps/user-journey.service';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { FormsModule } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { MatDivider } from '@angular/material/divider';
import { MatButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'qa-sample-live-event-dialog',
  templateUrl: './sample-live-event-dialog.component.html',
  styleUrls: ['./sample-live-event-dialog.component.scss'],
  imports: [
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    MatRadioGroup,
    FormsModule,
    MatIcon,
    MatRadioButton,
    MatDivider,
    MatDialogActions,
    MatButton,
    MatDialogClose,
    TranslateModule,
  ],
})
export class SampleLiveEventDialogComponent {
  liveEventType = 'Default';

  constructor(
    public dialogRef: MatDialogRef<SampleLiveEventDialogComponent>,
    private userJourney: UserJourneyService
  ) {}

  onClick() {
    this.userJourney.set('addedTemplateLiveEvent');
    this.dialogRef.close({ data: this.liveEventType });
  }
}
